<template>
  <!-- 术语列表 -->
  <div class="term">
    <el-dialog
      width="60%"
      title="术语"
      :visible="visible"
      :close-on-click-modal="false"
      v-dialogDrag
      @close="closeDialog"
      center
    >
      <section class="h-450 termTable">
        <avue-form :option="termFormOption" v-model="termForm" ref="termForm">
          <template slot="menuForm">
            <el-button
              icon="el-icon-check"
              type="primary"
              @click="handleSubmit"
            >
              添加
            </el-button>
          </template>
        </avue-form>
        <div class="d-f justify-e m-b-10">
          <el-tooltip
            class="item"
            effect="dark"
            content="仅支持xls,xlsx格式，第一列为术语原文，第二列为术语译文"
            placement="top-start"
          >
            <el-upload
              v-if="taskType == 1"
              class="m-r-10"
              ref="upload"
              :before-upload="beforeUpload"
              :show-file-list="false"
              :data="importObj"
              :action="uploadurl"
              accept=".xls,.xlsx"
              :on-success="uploadSuccess"
            >
              <el-button slot="trigger" type="primary" plain>
                批量导入术语
              </el-button>
            </el-upload>
          </el-tooltip>
          <el-button type="primary" plain @click="exportTerm">
            导出列表术语
          </el-button>
        </div>
        <!-- <div class="termTable h-260"> -->
        <avue-crud :option="termOption" :data="termData" @row-del="rowDel">
          <template slot="createTime" slot-scope="scope">
            <span>{{ formatDate(scope.row.createTime) }}</span>
          </template>
        </avue-crud>
        <!-- </div> -->
      </section>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from '@/util/date';
import { termOption, termFormOption } from '@/const/crud/qc/qcflow';
import {
  qcTermList,
  qcTermDelete,
  deleteTerm,
  qcTermCheckBeforeAdd,
  addTerm,
  updateTerm,
  qcTermExport,
  addTermBatch,
} from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import { TASK_TYPE } from '@/views/qc/const';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'TermDialog',
  props: [
    'type',
    'visible',
    'checkedLabel', // 鼠标选中文字
    'staParams', // 上报公共参数
    'orderId', // 当前订单id
    'qcTaskId',
    'taskType', // 1，主质控，2子质控
  ],
  data() {
    return {
      termOption: termOption,
      termFormOption: termFormOption,
      termData: [],
      termForm: {},
      uploadurl: '',
      importObj: {},
    };
  },
  computed: {
    ...mapGetters(['permissions', 'userInfo']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    this.importObj.orderId = this.orderId;
    this.importObj.staffId = this.userInfo.staffId;
    if (this.taskType == TASK_TYPE.son) {
      this.termOption.delBtn = false;
    } else {
      this.termOption.delBtn = true;
    }
  },
  watch: {
    visible(val) {
      // 弹窗每次出现都要拉取术语列表
      if (val) {
        this.getTermList();
        this.uploadurl =
          this.baseUrl + '/dotadmin/dotadmin/qcflow/addTermBatch';
      }
    },
  },
  methods: {
    beforeUpload(file) {
      console.log('-------', file);
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (extension.indexOf('xls') > 0) {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
      }
    },
    uploadSuccess(res) {
      console.log(res);
      if (res.code === 0) {
        this.$message.success('文件导入成功，请稍后查看');
      } else {
        this.$message.error(res.msg);
      }
    },

    // 术语导出
    exportTerm() {
      qcTermExport({
        orderId: this.orderId,
      }).then((res) => {
        let a = res.headers['content-disposition'];
        let fileName = decodeURIComponent(a.substr(a.indexOf('=') + 1));
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    // 非Action：拉取术语列表接口逻辑
    loadTermListSvr() {
      qcTermList(this.orderId).then((res) => {
        const data = res?.data?.data || [];
        this.termData = data;
      });
    },
    // Action：拉取术语列表
    getTermList() {
      this.loadTermListSvr();
      if (this.type === 'src') {
        this.termForm.srcText = this.checkedLabel;
      }
      if (this.type === 'target' || this.type === 'peTarget') {
        this.termForm.tranText = this.checkedLabel;
      }
      statistics(
        Object.assign(
          {
            event_name: '术语',
            event_type: 'click',
            class_name: 'qcTermList',
            qcTermList: '/dotadmin/dotadmin/qc/qcTermList',
            event_params: '{orderId:pageQuery.orderId}',
          },
          this.staParams,
        ),
      );
    },
    // 非Action，调删除术语接口逻辑
    deleteTermSvr(confirmText, row, data) {
      this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteTerm({
            srcText: row.srcText,
            oldTermId: data?.id ?? '',
            id: row.id,
            orderId: this.orderId,
            qcTaskId: this.qcTaskId,
          }).then((res) => {
            if (res?.data?.data > 0) {
              this.$message.success('删除成功');
              this.loadTermListSvr();
            } else {
              this.$message.error('删除失败');
            }
          });
        })
        .catch(() => {});
    },
    // Action：删除术语
    rowDel(row) {
      qcTermDelete({ oldTermId: row.oldTermId }).then((res) => {
        const data = res?.data?.data;
        const confirmText = data
          ? `此操作将会导致该术语还原为项目加持的原始版本，译文为:"${data.tranText}"，请确认是否继续删除`
          : `是否确认删除术语: ${row.srcText}`;
        this.deleteTermSvr(confirmText, row, data);
      });
    },
    // 非Action：更新术语
    updateTermSvr(data) {
      return updateTerm({
        srcText: this.termForm.srcText.trim(),
        tranText: this.termForm.tranText.trim(),
        id: data.id,
        orderId: this.orderId,
        qcTaskId: this.qcTaskId,
        remark: this.termForm.remark,
      });
    },
    // 非Action：添加术语
    addTermSvr(data) {
      const params = {
        srcText: this.termForm.srcText.replace(/\r\n/g, '').trim(),
        tranText: this.termForm.tranText.replace(/\r\n/g, '').trim(),
        orderId: this.orderId,
        qcTaskId: this.qcTaskId,
        taskType: Number(this.taskType),
        remark: this.termForm.remark,
      };
      if (data?.id) {
        params.oldTermId = data.id;
      }
      return addTerm(params);
    },
    // 添加术语提交
    handleSubmit() {
      if (!this.termForm.srcText?.trim()) {
        this.$message.warning('请输入原文');
        return;
      }
      if (!this.termForm.tranText?.trim()) {
        this.$message.warning('请输入译文');
        return;
      }
      // TODO 命名改为termCheck之类的
      qcTermCheckBeforeAdd({
        srcText: this.termForm.srcText?.trim(),
        orderId: this.orderId,
        taskType: Number(this.taskType),
      }).then((res) => {
        const data = res?.data?.data;
        if (data) {
          if (data.tranText === this.termForm.tranText) {
            return this.$message.warning('术语已存在');
          }
          // TODO: 这个-4需要提取常量，语义化
          if (data.oldTermId === '-4') {
            return this.$message.warning(
              '存在译员新增待审核或已采纳术语，不能添加',
            );
          }
          let message = `${
            data.oldTermId ? '您已经添加过该术语' : '该术语已在项目中存在'
          }， 译文为: "${data.tranText}" ，是否覆盖修改`;
          this.$confirm(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            const termPromise = data.oldTermId
              ? this.updateTermSvr(data)
              : this.addTermSvr(data);
            termPromise.then((res) => {
              if (res?.data?.data > 0) {
                this.$message.success('添加成功');
              }
              // 添加或者更新完术语，需要刷一下术语列表
              this.loadTermListSvr();
            });
          });
        } else {
          this.addTermSvr().then((res) => {
            if (res?.data?.data > 0) {
              this.$message.success('添加成功');
            }
            // 添加或者更新完术语，需要刷一下术语列表
            this.loadTermListSvr();
          });
          this.$refs.termForm.resetForm();
        }
      });
    },
    // 关闭弹窗回调
    closeDialog() {
      this.termForm.srcText = '';
      this.termForm.tranText = '';
      this.$emit('update:visible', false);
    },
    // 工具方法
    formatDate(time) {
      if (time == null) {
        return '';
      }
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
  },
};
</script>
<style lang="scss" scope>
.termTable {
  overflow-y: scroll;
}
textarea {
  user-select: none;
}
</style>
